import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { memo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { BackdropUI } from './styles/input-control-styles';

function Backdrop(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused;
  return createElement(BackdropUI, {
    "aria-hidden": "true",
    className: "components-input-control__backdrop",
    disabled: disabled,
    isFocused: isFocused
  });
}

var MemoizedBackdrop = memo(Backdrop);
export default MemoizedBackdrop;
//# sourceMappingURL=backdrop.js.map